import { Link, useLocation } from "react-router-dom";
import "./NavigationBar.css";
import Logo from "../../Images/Garvana_Logo.png";

export default function NavigationBar({ menuOpen, setMenuOpen }) {
  const location = useLocation();
  const closeMenu = () => setMenuOpen(false);

  const navItems = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Gallery", path: "/gallery" },
    { name: "About Us", path: "/about" },
    { name: "Contact Us", path: "/contact" },
    { name: "Our Products", path: "/products" },
  ];

  return (
    <>
      {/* DESKTOP NAVIGATION */}
      <nav className="nav-desktop">
        {navItems.map((item) => (
          <Link
            key={item.path}
            className={`nav-link ${
              location.pathname === item.path ? "active" : ""
            }`}
            to={item.path}
          >
            {item.name}
          </Link>
        ))}
      </nav>

      {/* MOBILE DRAWER */}
      <div className={`drawer ${menuOpen ? "open" : ""}`}>
        <div className="drawer-header">
          <img src={Logo} alt="Garvana" className="drawer-logo" />
          <button className="drawer-close" onClick={closeMenu}>✕</button>
        </div>

        {navItems.map((item) => (
          <Link
            key={item.path}
            className={`drawer-item ${
              location.pathname === item.path ? "active" : ""
            }`}
            onClick={closeMenu}
            to={item.path}
          >
            {item.name}
          </Link>
        ))}
      </div>
    </>
  );
}
